<div class="card-inner-main-div">
    <div class="card-main-title">
        <h4 class="card-title">{{ 'Exposure Reduction Plan Status' | translate }}</h4>
    </div>
    <div class="plan-status-graph-div"><img alt="" src="assets/images/Exposure-Reduction-Plan-Status.png">
    </div>
</div>